import React, { useEffect, useMemo, useState } from 'react';
import { Row, Col, ListGroup, Button, Offcanvas } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import QuickStartSection from '../components/sections/QuickStart';
import WhatIsLaeyerz from '../components/sections/QuickStart/WhatIsLaeyerz';
import InstallLaeyerz from '../components/sections/QuickStart/InstallLaeyerz';
import FirstTestCase from '../components/sections/QuickStart/FirstTestCase';
import WhatIsAWorkflow from '../components/sections/BuildAWorkflow/WhatIsAWorkflow';
import WorkflowNode from '../components/sections/BuildAWorkflow/WorkflowNode';
import WorkflowAction from '../components/sections/BuildAWorkflow/WorkflowAction';
import DataConnections from '../components/sections/BuildAWorkflow/DataConnections';
import WorkflowEdges from '../components/sections/BuildAWorkflow/WorkflowEdges';
import WorkflowEvaluate from '../components/sections/BuildAWorkflow/WorkflowEvaluate';
import WorkflowAppState from '../components/sections/BuildAWorkflow/WorkflowAppState';
import CustomNodes from '../components/sections/CustomNodes/CustomNodes';
import FlowCreator from '../components/sections/BuildAWorkflow/FlowCreator';
import APIKeysandConfig from '../components/sections/BuildAWorkflow/APIKeysandConfig';
import VisualizeWorkflow from '../components/sections/Visualize/VisualizeWorkflow';

import WhatIsAnAgent from '../components/sections/BuildAgents/WhatIsAnAgent';
import ReActAgent from '../components/sections/BuildAgents/ReActAgent';
import AgentTools from '../components/sections/BuildAgents/AgentTools';
import RunAgent from '../components/sections/BuildAgents/RunAgent';

import WhatIsAgenticWorkflow from '../components/sections/BuildAgenticWorkflows/WhatIsAgenticWorkflow';
import AgentSetup from '../components/sections/BuildAgenticWorkflows/AgentSetup';
import WorkflowSetup from '../components/sections/BuildAgenticWorkflows/WorkflowSetup';
import RunningAgenticWorkflow from '../components/sections/BuildAgenticWorkflows/RunningAgenticWorkflow';

import LLMNodes from '../components/sections/Prebuilt/LLMNodes';
import VectorStores from '../components/sections/Prebuilt/VectorStores';
import LaeyerzMap from '../components/sections/LaeyerzMap/LaeyerzMap';

import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile,
    deviceDetect
  } from "react-device-detect";

  

export default function DocsScreen() {

  const navigate = useNavigate();

  const [view, setView] = useState('what-is-laeyerz');
  const [showNav, setShowNav] = useState(false);
  const [mobileLike, setMobileLike] = useState(isMobile);

  useEffect(() => {
    const handleResize = () => {
      try {
        setMobileLike(isMobile || window.innerWidth < 992);
      } catch (e) {
        setMobileLike(isMobile);
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const nav = useMemo(() => ([
    {
      id: 'getting-started',
      title: 'Getting Started',
      items: [
        { id: 'what-is-laeyerz', title: 'What is Laeyerz?' },
        { id: 'install-laeyerz', title: 'Install Laeyerz' },
        { id: 'run-example', title: 'Run Example' },
      ],
    },
    {
      id: 'build-workflow',
      title: 'Build a Workflow',
      items: [
        { id: 'what-is-a-workflow', title: 'What is a Workflow?' },
        { id: 'workflow-action', title: 'Actions' },
        { id: 'workflow-node', title: 'Nodes' },
        { id: 'flow-creator', title: 'Create Workflow' },
       
        { id: 'workflow-edges', title: 'Workflow Edges' },
        { id: 'data-connections', title: 'Data Connections' },
        { id: 'workflow-app-state', title: 'App State' },
        { id: 'workflow-evaluate', title: 'Evaluate the Flow' },
        { id: 'api-keys-and-config', title: 'API Keys and Config' },
      ],
    },
    {
        id: 'agents',
        title: 'Agents in Laeyerz',
        items: [
          { id: 'what-is-an-agent', title: 'What is an Agent?' },
          { id: 'react-agent', title: 'Agent' },
          { id: 'tools', title: 'Tools' },
          { id: 'agent-run', title: 'Run Agent' },
        ],
    },
    // {
    //   id: 'agenticworkflow',
    //   title: 'Agentic Workflows',
    //   items: [
    //     { id: 'what-is-an-agentic-workflow', title: 'What is an Agentic Workflow?' },
    //     { id: 'agent-setup', title: 'Setup the Agent' },
    //     { id: 'workflow-setup', title: 'Setup the Workflow' },
    //     { id: 'running-agentic-workflow', title: 'Running the Agentic Workflow' },
    //   ],
    // },
    // {
    //     id: 'custom-nodes',
    //     title: 'Custom Nodes',
    //     items: [
    //       { id: 'custom-nodes', title: 'Custom Nodes' },
    //     ],
    //   },
    // {
    //   id: 'visualize',
    //   title: 'Visualize',
    //   items: [
    //     { id: 'visualize-workflow', title: 'Visualize Workflow' },
    //   ],
    // },
    // {
    //   id: 'prebuilt',
    //   title: 'Prebuilt Nodes',
    //   items: [
    //     { id: 'llm-nodes', title: 'LLM Nodes' },
    //     { id: 'vector-stores', title: 'Vector Stores' },
    //   ],
    // },
    // {
    //   id: 'laeyerz-map',
    //   title: 'Laeyerz Map',
    //   items: [
    //     { id: 'laeyerz-map', title: 'Laeyerz Map' },
    //   ],
    // },
  ]), []);

  const flatNav = useMemo(() => {
    const items = [];
    nav.forEach(section => {
      section.items.forEach(item => items.push({ ...item, section: section.title }));
    });
    return items;
  }, [nav]);

  const currentIndex = useMemo(() => flatNav.findIndex(i => i.id === view), [flatNav, view]);
  const prevItem = currentIndex > 0 ? flatNav[currentIndex - 1] : null;
  const nextItem = currentIndex >= 0 && currentIndex < flatNav.length - 1 ? flatNav[currentIndex + 1] : null;

  const renderContent = () => {
    switch (view) {
      case 'what-is-laeyerz':
        return <WhatIsLaeyerz />;
      case 'install-laeyerz':
        return <InstallLaeyerz />;
      case 'run-example':
        return <FirstTestCase />;
      case 'what-is-a-workflow':
        return <WhatIsAWorkflow />;
      case 'workflow-action':
        return <WorkflowAction />;
      case 'workflow-node':
        return <WorkflowNode />;
      case 'flow-creator':
        return <FlowCreator />;
      case 'data-connections':
        return <DataConnections />;
      case 'workflow-edges':
        return <WorkflowEdges />;
      case 'workflow-app-state':
        return <WorkflowAppState />;
      case 'workflow-evaluate':
        return <WorkflowEvaluate />;
      case 'api-keys-and-config':
        return <APIKeysandConfig />;

      case 'what-is-an-agent':
        return <WhatIsAnAgent />;
      case 'react-agent':
        return <ReActAgent />;
      case 'tools':
        return <AgentTools />;
      case 'agent-run':
        return <RunAgent />;

      case 'what-is-an-agentic-workflow':
        return <WhatIsAgenticWorkflow />;
      case 'agent-setup':
        return <AgentSetup />;
      case 'workflow-setup':
        return <WorkflowSetup />;
      case 'running-agentic-workflow':
        return <RunningAgenticWorkflow />;

      case 'custom-nodes':
        return <CustomNodes />;

/*       case 'visualize-workflow':
        return <VisualizeWorkflow />;


      case 'what-is-an-agent':
        return <WhatIsAnAgent />; */


      case 'llm-nodes':
        return <LLMNodes />;

      case 'vector-stores':
        return <VectorStores />;

      case 'laeyerz-map':
        return <LaeyerzMap />;
       
      default:
        return (
          <div style={{ padding: '16px' }}>
            <p className='h5' style={{ margin: 0 }}>Content coming soon.</p>
          </div>
        );
    }
  };

  return (

    <>
    {/* Mobile-like top bar */}
    {mobileLike && (
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 12px', position: 'sticky', top: 0, zIndex: 1030, background: '#fff', borderBottom: '1px solid #eee' }}>
        <Button variant="outline-secondary" size="sm" onClick={() => setShowNav(true)}>Menu</Button>
        <div className='h5' style={{ margin: 0 }}>Docs</div>
        
      </div>
    )}

    <Row className="g-0 flex-md-nowrap" style={{ alignItems: 'stretch' }}>
      {/* Sidebar - desktop */}
      <Col md="auto" className={mobileLike ? 'd-none' : 'd-block'} style={{ flex: '0 0 260px', maxWidth: '260px', minWidth: '220px', borderRight: '1px solid #eee', maxHeight: '90vh', overflow: 'scroll' }}>
        <div className="sidebar" style={{ position: 'sticky', top: 0, padding: '16px 12px' }}>
          {nav.map(section => (
            <div key={section.id} style={{ marginBottom: '16px', borderBottom: '1px solid #eee' }}>
              <div className='text-uppercase text-muted' style={{ fontSize: '0.75rem', fontWeight: 700, letterSpacing: '0.04em', margin: '8px 12px' }}>
                {section.title}
              </div>
              <ListGroup variant="flush">
                {section.items.map(item => (
                  <ListGroup.Item
                    key={item.id}
                    action
                    active={view === item.id}
                    onClick={() => setView(item.id)}
                    style={{
                      border: 'none',
                      borderRadius: 0,
                      cursor: 'pointer',
                      fontWeight: 600,
                      backgroundColor: view === item.id ? '#667eea' : 'transparent',
                      color: view === item.id ? '#fff' : 'inherit',
                    }}
                  >
                    {item.title}
                  </ListGroup.Item>
                ))}
              </ListGroup>
            </div>
          ))}
        </div>
      </Col>

      {/* Content */}
      <Col style={{ flex: '1 1 auto', minWidth: 0, padding: '16px', marginLeft:'20px', marginRight:'20px', marginTop:'20px', marginBottom:'20px' }}>
        {renderContent()}

        {/* Prev/Next navigation */}
        <div style={{ marginTop: '24px' }}>
          <Row className="g-3">
            {prevItem && (
              <Col xs={12} md={6}>
                <div
                  role="button"
                  onClick={() => setView(prevItem.id)}
                  style={{
                    border: '1px solid #e5e7eb',
                    borderRadius: '10px',
                    padding: '12px 14px',
                    cursor: 'pointer',
                    background: '#fff'
                  }}
                >
                  <div style={{ color: '#6b7280', fontSize: '12px', textTransform: 'uppercase', fontWeight: 700, letterSpacing: '0.03em' }}>
                    ← Previous
                  </div>
                  <div style={{ marginTop: '4px', fontWeight: 600 }}>
                    {prevItem.title}
                  </div>
                </div>
              </Col>
            )}
            {nextItem && (
              <Col xs={12} md={6} className={prevItem ? '' : 'ms-auto'}>
                <div
                  role="button"
                  onClick={() => setView(nextItem.id)}
                  style={{
                    border: '1px solid #e5e7eb',
                    borderRadius: '10px',
                    padding: '12px 14px',
                    cursor: 'pointer',
                    background: '#fff',
                    textAlign: 'right'
                  }}
                >
                  <div style={{ color: '#6b7280', fontSize: '12px', textTransform: 'uppercase', fontWeight: 700, letterSpacing: '0.03em' }}>
                    Next →
                  </div>
                  <div style={{ marginTop: '4px', fontWeight: 600 }}>
                    {nextItem.title}
                  </div>
                </div>
              </Col>
            )}
          </Row>
        </div>
      </Col>
    </Row>

    {/* Simple overlay navigation panel for mobile-like layouts */}
    {mobileLike && showNav && (
      <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 2000, pointerEvents: 'auto' }}>
        <div
          className="sidebar"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '82vw',
            maxWidth: '340px',
            height: '100vh',
            background: '#fff',
            boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
            overflowY: 'auto',
            padding: '16px 12px',
            borderRight: '1px solid #eee'
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '4px 8px', marginBottom: '8px' }}>
            <div className='h5' style={{ margin: 0 }}>Docs</div>
            <Button variant="light" size="sm" onClick={() => setShowNav(false)}>Close</Button>
          </div>
          {nav.map(section => (
            <div key={section.id} style={{ marginBottom: '16px' }}>
              <div className='text-uppercase text-muted' style={{ fontSize: '0.75rem', fontWeight: 700, letterSpacing: '0.04em', margin: '8px 12px' }}>
                {section.title}
              </div>
              <ListGroup variant="flush">
                {section.items.map(item => (
                  <ListGroup.Item
                    key={item.id}
                    action
                    active={view === item.id}
                    onClick={() => { setView(item.id); setShowNav(false); }}
                    style={{
                      border: 'none',
                      borderRadius: 0,
                      cursor: 'pointer',
                      fontWeight: 600,
                      backgroundColor: view === item.id ? '#667eea' : 'transparent',
                      color: view === item.id ? '#fff' : 'inherit',
                    }}
                  >
                    {item.title}
                  </ListGroup.Item>
                ))}
              </ListGroup>
            </div>
          ))}
        </div>
      </div>
    )}
    
    </>

  );
}